const IosPage = (props: { children? }) => {
  return <div className="bg-gray-100 dark:bg-gray-900">{props.children}</div>;
};

export default IosPage;
